import { UnorderedListOutlined } from "@ant-design/icons"
import { Card, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

/**
 * The derived project types as a narrow vertical list beside the compliance
 * cards. Content-driven height: an empty list is one line of text, not a tall
 * blank card.
 */
export const ProjectTypesPanel = ({ types }: { types: string[] }) => {
  const { t } = useTranslation()

  return (
    <Card
      size={"small"}
      title={
        <Flex align={"center"} gap={8}>
          <UnorderedListOutlined aria-hidden className={"text-gray-400"} />
          <span>{t("subcontractorDetail.projectTypes")}</span>
        </Flex>
      }
    >
      {types.length ? (
        <Flex vertical>
          {types.map((type, index) => (
            <div
              key={type}
              className={
                index === 0
                  ? "py-1.5"
                  : "border-0 border-t border-solid border-gray-100 py-1.5"
              }
            >
              <Text className={"break-words"}>{type}</Text>
            </div>
          ))}
        </Flex>
      ) : (
        <Text type={"secondary"}>{t("subcontractorDetail.noProjectTypes")}</Text>
      )}
    </Card>
  )
}
